import { http, tryHttp } from '@pequity/shared/axios/http';

export const fetchFxRates = () => {
  return tryHttp(http.get<Record<string, number>>('/employeesv2/fx-rates'));
};
